import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { WorkstationCategoryController } from './workstation-category.controller';
import { WorkstationCategoryService } from './workstation-category.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { WorkstationCategoryAdapter } from './dto/workstation-category.adapter';
import { WorkstationCategories } from './workstation-category.entity';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([WorkstationCategories]),
  ],
  controllers: [WorkstationCategoryController],
  providers: [WorkstationCategoryService,WorkstationCategoryAdapter,ApplicationExceptionHandler,LogsService]
})
export class WorkstationCategoryModule {}
